<template>
  <AppPageCard>
    <template #card-title> Teacher Individual Yearly Attendance</template>
    <div>
      <span
        class="
          text-muted
          font-weight-bold font-size-base
          d-none d-md-inline
          mr-1
        "
      >
        {{ $t("EMPLOYEE.EMP") }}
      </span>
      <span
        class="
          text-dark-50
          font-weight-bolder font-size-base
          d-none d-md-inline
          mr-3
        "
      >
        {{ getTitle() }}
      </span>
      <span
        class="
          text-muted
          font-weight-bold font-size-base
          d-none d-md-inline
          mr-1
        "
      >
        {{ "Attendance Year" }}
      </span>
      <span
        class="
          text-dark-50
          font-weight-bolder font-size-base
          d-none d-md-inline
          mr-3
        "
      >
        {{ getYear() }}
      </span>
      <IndividualEmployeeAttendanceYearlyPageTable
        :is-busy="isBusy"
        :items="items"
        @showIndividualAttendance="openModal"
      ></IndividualEmployeeAttendanceYearlyPageTable>
    </div>
    <TeacherIndividualMonthlyAttendanceModal
      :employee="employee"
      :date="date"
      :date-info="dateInfo"
    ></TeacherIndividualMonthlyAttendanceModal>
  </AppPageCard>
</template>

<script>
import dayjs from "dayjs";
import { mapGetters } from "vuex";
import AppPageCard from "@/modules/core/components/shared/card/AppPageCard";
import IndividualEmployeeAttendanceYearlyPageTable from "@/modules/school/components/shared/management/attendance/table/IndividualEmployeeAttendanceYearlyPageTable";
import TeacherIndividualMonthlyAttendanceModal from "@/modules/school/components/management/attendance/teacher/TeacherIndividualMonthlyAttendanceModal";

export default {
  name: "TeacherIndividualYearlyAttendancePage",
  components: {
    TeacherIndividualMonthlyAttendanceModal,
    IndividualEmployeeAttendanceYearlyPageTable,
    AppPageCard,
  },
  data() {
    return {
      isBusy: false,
      date: new Date(dayjs().format()),
      dateFilter: new Date(dayjs().format()),
      employee: {},
      dateInfo: {},
    };
  },
  mounted() {
    this.setDate();
    this.fetch();
  },
  methods: {
    getTitle() {
      return this.$route.query.name;
    },

    getYear() {
      return this.$route.query.year;
    },

    setDate() {
      const objectSupport = require("dayjs/plugin/objectSupport");
      dayjs.extend(objectSupport);

      const date = dayjs({
        year: this.getYear(),
      });

      console.log("Date individual: ", date);

      this.dateFilter = date.format();

      this.$store.dispatch("changeTeacherEmployeeYearlyAttendanceListDate", {
        date: date.format(),
      });
    },

    fetch() {
      this.isBusy = true;
      this.$store
        .dispatch("fetchTeacherIndividualEmployeeYearlyAttendanceList", {
          id: this.$route.query.id,
        })
        .finally(() => (this.isBusy = false));
    },

    openModal(data) {
      console.log("Data when open modal: ", data);

      const item = data.item;
      console.log("Selected item ", item);
      this.employee = item.employee;
      console.log("Checking employee", this.employee);

      const objectSupport = require("dayjs/plugin/objectSupport");
      dayjs.extend(objectSupport);

      const date = dayjs({
        year: this.getYear(),
        month: data.item.month_number - 1,
      });
      this.date = dayjs(date).toDate();

      console.log("Selected date : ", this.date);

      this.$store.commit("setTeacherIndividualAttendancePage", 1);

      this.$store.dispatch("fetchTeacherIndividualAttendance", {
        id: this.employee.id,
        date: this.date,
        date_type: 1,
      });

      this.dateInfo = {
        date: this.date,
        date_type: 1,
      };

      this.$bvModal.show("employee-monthly-attendance-modal");
    },
  },
  computed: {
    ...mapGetters({
      items: "getTeacherIndividualEmployeeYearlyAttendanceList",
    }),
  },
};
</script>

<style scoped></style>
